// extracted by mini-css-extract-plugin
export var blue = "_3g-f";
export var brand = "_3g-b";
export var darkGrey = "_3g-e";
export var disabled = "_3g-4";
export var disabledSubtle = "_3g-5";
export var error = "_3g-6";
export var green = "_3g-g";
export var grey = "_3g-d";
export var icon = "_3g-0";
export var inherit = "_3g-a";
export var lightGrey = "_3g-c";
export var orange = "_3g-i";
export var pink = "_3g-k";
export var primary = "_3g-1";
export var purple = "_3g-l";
export var red = "_3g-j";
export var secondary = "_3g-2";
export var success = "_3g-9";
export var tertiary = "_3g-3";
export var warning = "_3g-7";
export var warningSecondary = "_3g-8";
export var white = "_3g-m";
export var yellow = "_3g-h";